<template>
  <router-view />
</template>

<script>
import storeMixin, {
  unRegisterMixin,
} from '@quisit/mipe-utils/mixins/storeGenerator';
const STORE_MODULE_NAME = 'ProvRemedyReqManagmentModule';

export default {
  name: 'WrapperProvRemedyReqManagment',
  mixins: [storeMixin, unRegisterMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
